module.exports = __webpack_public_path__ + "static/media/ad_manager360_header.3b38ca3d.png";